import LegalPageLayout, { Section } from "@/pages/LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout
      label="§ LEGAL · PRIVACY"
      title="Privacy Policy"
      updated="17 August 2026"
    >
      <p>
        This Privacy Policy explains how Agenaix collects, uses, stores, and
        protects personal data when you visit agenaix.com or use an authorised
        Agenaix account. Agenaix is currently a pre-launch project based in
        Dubai, United Arab Emirates. Privacy enquiries may be sent to
        agenaix.ai@gmail.com.
      </p>

      <Section title="1. Data we collect">
        <p>
          We may collect your name, email address, optional company information,
          authentication and account information, project requests, files,
          messages, assistant conversations, support communications, and other
          information you choose to provide.
        </p>
        <p>
          We may also collect technical and security information such as IP
          address, browser and device information, timestamps, authentication
          events, request logs, and diagnostic records.
        </p>
      </Section>

      <Section title="2. How we use personal data">
        <p>
          We use personal data to provide and secure authorised access, respond
          to enquiries, review project requirements, operate requested platform
          features, communicate about accounts or services, diagnose problems,
          prevent misuse, maintain records, and comply with applicable law.
        </p>
        <p>
          We do not sell personal data. We do not use customer files or private
          project content to train public AI models.
        </p>
      </Section>

      <Section title="3. AI-assisted features">
        <p>
          Content submitted to assistant or document features may be processed
          by configured AI systems to generate responses or perform requested
          functions. AI output may be incomplete or inaccurate and should be
          reviewed by a qualified person before it is relied upon.
        </p>
        <p>
          Do not submit sensitive personal data, secrets, regulated information,
          or third-party confidential material unless it is necessary, lawful,
          and you are authorised to provide it.
        </p>
      </Section>

      <Section title="4. Service providers and international processing">
        <p>
          Agenaix uses service providers for authentication, database and file
          storage, hosting, security, communications, infrastructure, and
          software operations. These providers process data only as needed to
          supply their services or meet legal obligations.
        </p>
        <p>
          Some providers or infrastructure may be located outside the UAE.
          Where applicable, Agenaix will use appropriate contractual, technical,
          and organisational safeguards for such processing.
        </p>
      </Section>

      <Section title="5. Cookies and session technologies">
        <p>
          Agenaix may use essential browser storage, cookies, or similar
          technologies required for authentication, session continuity,
          security, and core platform operation. We do not currently use
          advertising cookies.
        </p>
      </Section>

      <Section title="6. Data retention">
        <p>
          We retain personal data only for as long as reasonably necessary for
          the purposes described here, including account operation, security,
          dispute handling, backups, and legal obligations. Retention periods
          depend on the type of data and the reason it is processed.
        </p>
      </Section>

      <Section title="7. Security">
        <p>
          We apply reasonable technical and organisational safeguards designed
          to protect personal data. No internet service or storage method can be
          guaranteed to be completely secure.
        </p>
      </Section>

      <Section title="8. Your rights">
        <p>
          Subject to applicable law, you may request access to, correction of,
          deletion of, restriction of, or a copy of your personal data, or
          object to certain processing and withdraw consent where processing is
          based on consent.
        </p>
        <p>
          Send requests to agenaix.ai@gmail.com. We may need to verify your
          identity before completing a request.
        </p>
      </Section>

      <Section title="9. Children">
        <p>
          Agenaix is intended for business users aged 18 or older. We do not
          knowingly offer accounts to children.
        </p>
      </Section>

      <Section title="10. Changes and contact">
        <p>
          We may update this policy as Agenaix develops or legal requirements
          change. The effective date above identifies the current version.
          Questions or requests may be sent to agenaix.ai@gmail.com.
        </p>
      </Section>
    </LegalPageLayout>
  );
}
